import { render, staticRenderFns } from "./tarnav.vue?vue&type=template&id=4c6e7637&scoped=true&"
import script from "./tarnav.vue?vue&type=script&lang=js&"
export * from "./tarnav.vue?vue&type=script&lang=js&"
import style0 from "./tarnav.vue?vue&type=style&index=0&id=4c6e7637&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e7637",
  null
  
)

export default component.exports